import React, { useState, useEffect } from "react";
import { useAuth } from "@/hooks/AuthContext";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { inr } from "@/App";
import { AddProjectDialog } from "./AddProjectDialog";
import { Loader2 } from "lucide-react";
import { MonthPicker } from "@/components/month-picker";

export function DashboardHeader({
  month,
  setMonth,
  dashboardData,
  actions,
  isLoading,
}) {
  const { user } = useAuth();
  const [opEx, setOpEx] = useState("");
  const [isSavingOpEx, setIsSavingOpEx] = useState(false);
  const [isSwitchingMethod, setIsSwitchingMethod] = useState(false);

  useEffect(() => {
    setOpEx(String(dashboardData.monthly_operational_cost || ""));
  }, [dashboardData.monthly_operational_cost]);

  const handleSaveOpEx = async () => {
    setIsSavingOpEx(true);
    try {
      await actions.saveOpEx(Number(opEx || 0));
    } catch (error) {
      console.error("Failed to save OpEx:", error);
      // Optional: show a user-friendly error message, e.g., toast or alert
    } finally {
      setIsSavingOpEx(false); // ensures it resets even if there's an error
    }
  };


  const handleSwitchMethod = async () => {
    setIsSwitchingMethod(true);
    await actions.switchOverheadMethod(dashboardData.overhead_method);
    setIsSwitchingMethod(false);
  };

  return (
    <header className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">
          Master Projects Dashboard
        </h1>
        {/* <p className="text-muted-foreground">
          Cumulative OpEx:{" "}
          {inr.format(dashboardData.cumulative_operational_cost || 0)}
        </p> */}
      </div>
      <div className="flex flex-wrap items-end gap-4">
        {/* <div>
          <Label htmlFor="month-picker">Month</Label>
          <MonthPicker
            id="month-picker"
            type="month"
            value={month}
            onChange={(e) => setMonth(e)}
            disabled={isLoading}
          />
        </div> */}
        {user?.role === "ADMIN" && (
          <>
            <div className="flex items-end gap-2">
              <div>
                <a href="/opex" >Monthly OpEx (₹)</a>
                {/* <Input
                        id="op-ex"
                        placeholder="Enter amount"
                        value={opEx}
                        onChange={(e) => setOpEx(e.target.value)}
                        disabled={isLoading}
                    /> */}
              </div>
              {/* <Button onClick={handleSaveOpEx} disabled={isLoading || isSavingOpEx}>
                    {isSavingOpEx && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
                    Save
                  </Button> */}
            </div>
            {/* <Button
              variant="outline"
              onClick={handleSwitchMethod}
              disabled={true || isLoading || isSwitchingMethod}
            >
              {isSwitchingMethod && (
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              )}
              Overhead: {dashboardData.overhead_method.replace("_", " ")}
            </Button> */}

            <AddProjectDialog onProjectAdded={actions.refresh} />
          </>
        )}
      </div>
    </header>
  );
}
